import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";

const SSOProtectedRoute = ({ component: Component, ...rest }) => {
  const isSSOAuthenticated = !!localStorage.getItem("ssoLoginData");

  return (
    <Route
      {...rest}
      render={(props) =>
        isSSOAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/session-expired",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

SSOProtectedRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  location: PropTypes.object,
};

export default SSOProtectedRoute;
